const getters = {
  isLogin (state) {
    if (!state.isLogin) {
      state.isLogin = window.sessionStorage.getItem('isLogin')
    }
    return state.isLogin
  },
  token (state) {
    if (!state.token) {
      state.token = window.sessionStorage.getItem('token')
    }
    return state.token
  },
  username (state) {
    if (!state.username) {
      state.username = window.sessionStorage.getItem('username')
    }
    return state.username
  },
  authMenu (state) {
    console.log('authMenu store', state.authMenu)
    if (!state.authMenu) {
      state.authMenu = window.sessionStorage.getItem('authMenu')
      console.log('authMenu store', state.authMenu)
    }
    return state.authMenu
  },
  baseMenu (state) {
    if (!state.baseMenu) {
      state.baseMenu = window.sessionStorage.getItem('baseMenu')
    }
    return state.baseMenu
  },
  authButton (state) {
    if (!state.authButton) {
      state.authButton = window.sessionStorage.getItem('authButton')
    }
    return state.authButton
  },
  showMenuList (state) {
    if (!state.showMenuList) {
      state.showMenuList = window.sessionStorage.getItem('showMenuList')
    }
    return state.showMenuList
  },
  hasMenu (state) {
    return state.hasMenu
  }
}
export default getters
